module.exports = __webpack_public_path__ + "static/media/42.5050ba06.png";